import type { ProductsPageProducts } from "../types/Growth/ProductsType";

interface ISeoStructure {
    title: string;
    description: string;
    h1?: string;
}

type ProductsSeoStructure = {
    [K in ProductsPageProducts]: ISeoStructure;
};

export const getProductPageSeo = (productName: ProductsPageProducts) => {
    const productsStructure: ProductsSeoStructure = {
        "auto-promotion": {
            title: "Boost Instagram Engagement Automatically | inSOCIAL Auto Promotion",
            description:
                "Amplify your Instagram presence effortlessly with inSOCIAL's Auto Promotion. Increase story views, poll responses, and quiz participation automatically. Grow your following and become a top influencer today!",
        },
        "auto-boost": {
            title: "Skyrocket Your Instagram Growth | inSOCIAL Auto Boost",
            description:
                "Transform your Instagram presence with inSOCIAL's Auto Boost. Gain real followers, boost engagement, and become an influencer effortlessly. 100% Instagram-compliant. Start your journey to stardom today!",
        },
        "comment-tracker": {
            title: "Instagram Comment Tracker: Boost Engagement & Sales | inSOCIAL",
            description:
                "Transform conversations into leads with inSOCIAL's Comment Tracker. Monitor, analyze, and respond to Instagram comments effortlessly. Maximize your social media marketing success - try it now!",
        },
        "direct-messaging": {
            title: "Boost Instagram Engagement With Automated DMs | inSOCIAL Direct Messaging",
            description:
                "Skyrocket your Instagram presence with inSOCIAL's automated Direct Messaging. Personalize interactions, save time, and grow your audience effortlessly. Try our powerful DM tool now and transform your Instagram strategy!",
        },
        "influencer-discovery": {
            title: "Discover Top Instagram Influencers | inSOCIAL Influencer Discovery Tool",
            description:
                "Unlock your marketing potential with inSOCIAL's Influencer Discovery tool. Find the right influencers based on location, age, gender, and interests. Analyze engagement, followers, and content to expand your reachand boost your digital marketing efforts today!",
        },
        "hashtag-generator": {
            title: "Find the Best Hashtags for Instagram | inSOCIAL Hashtag Generator",
            description:
                "Maximize your Instagram visibility with inSOCIAL's advanced Hashtag Generator. Find & Generate viral-worthy hashtags for Instagram in seconds! Achieve higher visibility and reach more of your target audience. Try it now!",
        },
        "schedule-posting": {
            title: "Schedule Instagram Posts: Boost Engagement & Save Time | inSOCIAL",
            description:
                "Automate your Instagram strategy with inSOCIAL's powerful scheduling tool. Plan, schedule, and auto-post images, carousels, Stories, and Reels. Boost engagement, save time, and grow your audience effortlessly. Try inSOCIAL now!",
        },
    };

    return productsStructure[productName];
};

export const mainPageSeoStructure: ISeoStructure = {
    title: "Unlock Instagram Success: Save Time, Achieve Real Growth",
    description:
        "Transform your Instagram presence with inSOCIAL, the all-in-one platform trusted by top brands and agencies. Effortlessly optimize your workflow for authentic growth and measurable success, alongside thousands of marketers maximizing Instagram's potential every day.",
    h1: "Unlock Instagram Success: Save Time, Achieve Real Growth",
};

export const aboutUsSeoStructure: ISeoStructure = {
    title: "Unlock Your Instagram Success With inSOCIAL | Grow Your Business Today",
    description:
        "Discover inSOCIAL, your ultimate Instagram growth partner. inSOCIAL offers Auto Promotion, Auto Boost, Direct Messaging, Schedule Posting, Comment Tracker, Hashtag Generator, and Influencer Discovery tools. Start your journey to becoming Instagram-famous and boosting sales today.",
    h1: "About Us",
};

export const ourTeamSeoStructure: ISeoStructure = {
    title: "Our Team - inSOCIAL",
    description:
        "Discover the talented minds behind inSOCIAL's success. Find out our experience and expertise around Instagram Marketing.",
    h1: "Our Team",
};

export const contactUsSeoStructure: ISeoStructure = {
    title: "Contact inSOCIAL - Get Expert Instagram Marketing Support",
    description:
        "Boost your Instagram success with inSOCIAL's marketing tools. Connect with our team for personalized support, product info, or a free consultation. Elevate your social media strategy today!",
    h1: "Contact Us",
};

export const careersSeoStructure: ISeoStructure = {
    title: "Careers at inSOCIAL: Join Our Innovative Team | Apply Now!",
    description:
        "Discover exciting career opportunities at inSOCIAL. We're seeking passionate professionals to drive social media innovation. Explore open positions and apply today to shape the future of digital marketing.",
    h1: "Careers",
};

export const faqSeoStructure: ISeoStructure = {
    title: "inSOCIAL FAQ: Boost Your Instagram Growth | Get Answers & Start Today",
    description:
        "Discover how inSOCIAL's Instagram growth tools can skyrocket your presence. Find answers to common questions, learn about our powerful features, and start growing your account today. Get the facts and take action!",
    h1: "FAQ`s",
};

export const gdprSeoStructure: ISeoStructure = {
    title: "GDPR - inSOCIAL",
    description: "GENERAL DATA PROTECTION REGULATION",
    h1: "GENERAL DATA PROTECTION REGULATION",
};

export const termsSeoStructure: ISeoStructure = {
    title: "Terms & Conditions - inSOCIAL",
    description: "Terms & Conditions",
    h1: "Terms & Conditions",
};

export const privacySeoStructure: ISeoStructure = {
    title: "Privacy Policy - inSOCIAL",
    description: "Privacy Policy",
    h1: "Privacy Policy",
};

export const disclaimerSeoStructure: ISeoStructure = {
    title: "Disclaimer - inSOCIAL",
    description: "Disclaimer",
    h1: "Disclaimer",
};

export const siteMapSeoStructure: ISeoStructure = {
    title: "Site Map - inSOCIAL",
    description: "Site Map",
    h1: "Site Map",
};

export const blogPageSeoStructure: ISeoStructure = {
    title: "inSOCIAL Blog: Boost Your Instagram Strategy | Expert Tips & Trends",
    description:
        "Elevate your Instagram game with inSOCIAL's expert blog. Discover actionable tips, cutting-edge strategies, and industry trends to skyrocket engagement and grow your following. Start maximizing your social media impact today!",
    h1: "",
};
